import React, {useCallback} from 'react';

import {ProfileRecord} from 'src/openapi/admin/models/ProfileRecord';

import {FlatButton} from '@pb/kit-component-button';
import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import {Group} from '@pb/kit-component-group';
import {Scroll} from '@pb/kit-component-scroll';

import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';


type Props = {
    selectedRoles?: number[],
    onChange: (selectedRolesIds: number[]) => void,
    roles: Array<ProfileRecord>,
};

export const NotificationAdminProfileFilter = ({selectedRoles, onChange, roles}: Props) => {
    const changeLicenseType = useCallback((types: ChangeTreeType) => {
        onChange(types.checkedIdsList.map(Number));
    }, [onChange]);

    const selectAll = useCallback(() => {
        onChange(roles.map(({profileId}) => profileId));
    }, [onChange, roles]);

    const deselectAll = useCallback(() => {
        onChange([]);
    }, [onChange]);

    return (
        <Group direction="v" alignItems="start">
            <FlatButton onClick={selectedRoles?.length ? deselectAll : selectAll}>
                <b>{selectedRoles?.length ? 'Deselect All' : 'Select All'}</b>
            </FlatButton>
            <Scroll>
                <div style={{height: 300, width: '98%'}}>
                    <CheckBoxTree
                        checkedIdsList={selectedRoles?.map(String) || []}
                        data={
                            roles.map(({profileId, profileName}) => ({
                                id: profileId + '',
                                caption: profileName,
                            }))
                        }
                        onChange={changeLicenseType}
                    />
                </div>
            </Scroll>
        </Group>
    );
};
